
import {Timeline, TimelineLite} from "gsap";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpacierArcade} from "../SpacierArcade";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SASymbols} from "../symbols/SpacierArcadeReelSymbol";

export class SymbolOverlays implements GameRoundPresentation {
    private readonly _reelId:number;
    private _stopDelay:number;
    private _quickStopDelay:number;
    stagger?:number;
    abortStagger?:number;
    private _animationStarted:boolean;
    private _tl:TimelineLite;

    constructor(reelId:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this._stopDelay = SpacierArcade.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = SpacierArcade.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;
        //Override config
        if(stagger != undefined) {
            this._stopDelay = stagger;
        }
        if(abortStagger != undefined) {
            this._quickStopDelay = abortStagger;
        }

        // this.stagger = this._stopDelay;
        // this.abortStagger = this._quickStopDelay;
        this._animationStarted = false;
    }

    private hasWin(data:SpacierArcadeParsedGameData):boolean{
        let returnValue:boolean = false;
        data.overlayWildsMultipliers.filter((multi, index) => {
            if(multi.filter(m => m > 0).length > 0){
                returnValue = true;
            }
        });
        return returnValue;
    }

    protected isRespin() {
        return SpacierArcadeModeData.instance.mode == SpacierArcadeGameMode.RESPIN || SpacierArcadeModeData.instance.mode == SpacierArcadeGameMode.FREESPIN_RESPIN;
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        let tl:TimelineLite = new TimelineLite();
        tl.add(this.getOverlayAnim(data));
        this._tl = tl;
        return this._tl;
    }

    private getOverlayAnim(data:SpacierArcadeParsedGameData):TimelineLite{
        let overlayTimeLine = new TimelineLite();
        if(!this.hasWin(data) || (this.hasWin(data) && (data.mode == SpacierArcadeGameMode.NORMAL || data.mode === SpacierArcadeGameMode.FREESPIN) && ( this._reelId < 2 ||  (this.hasWildBefore(data) &&  data.mode == SpacierArcadeGameMode.NORMAL)) )) {
            return overlayTimeLine;
        }


        let existingOverlaySyms:string[] = this.getDistinctArrayItems(data.overlaySymbolsBeforeSpin);
        let newOverlaySyms:string[] = this.getDistinctArrayItems(data.newOverlaySymbols);
        const diffSyms:string[] =  newOverlaySyms.filter((item) => { return existingOverlaySyms.indexOf(item) < 0});

        if(diffSyms.length > 0 && this._reelId === 2 && this.isRespin()) {
            overlayTimeLine.add(this.animateOverlays(data, true, diffSyms),"+=0.1");
        }


        let hasNewOverlays:boolean = data.newOverlaySymbols[this._reelId].filter((sym) => { return sym !== null }).length > 0;
        if(hasNewOverlays) {
            overlayTimeLine.add(this.animateOverlays(data, ((data.mode == SpacierArcadeGameMode.NORMAL || data.mode === SpacierArcadeGameMode.FREESPIN) && this._reelId === 2), (diffSyms.length > 0 && this._reelId <=2 && this.isRespin()) ? existingOverlaySyms : newOverlaySyms),"+=0.1");
        }
        return overlayTimeLine;
    }

    private animateOverlays(data:SpacierArcadeParsedGameData, isFirst:boolean, symArray:string[]):TimelineLite{
        let tl:TimelineLite = new TimelineLite();
        tl.add(()=> {
            const loopCount: number = this._reelId + 1;
            let loopInitial: number = 0;

            for (let i: number = loopInitial; i < loopCount; i++) {
                let index: number = i;
                for (let j: number = 0; j < data.newOverlaySymbols[index].length; j++) {
                    if (data.newOverlaySymbols[index][j] !== null && (data.mode != SpacierArcadeGameMode.FREESPIN || (data.mode === SpacierArcadeGameMode.FREESPIN && data.newOverlaySymbols[index][j] !== SASymbols.W)) && symArray.indexOf(data.newOverlaySymbols[index][j]) >= 0) {
                        let oldsymbol: any = Reels.getSymbol(index, j);
                        if(oldsymbol) {
                            oldsymbol.changeState({ state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.excitmentPump});
                        }
                    }
                }
            }
        }, GameSetting.isFastSpin?  0.3 : 0)
        // tl.add(SpacierArcadeGameModuleConfig.spacierArcadeOverlayView.animateOverlays(data.newOverlaySymbols, newOverlaySyms, this._reelId, true), 0);
        return tl;
    }

    // public abort(isActive:boolean, data:SpacierArcadeParsedGameData):Timeline | null {
    //     if(isActive && this._tl) {
    //         return this._tl;
    //     }
    //     return null;
    // }

    private hasWildBefore(data:SpacierArcadeParsedGameData):boolean{
        let returnValue:boolean = true;
        data.newOverlaySymbols.filter((sym, index) => {
            if(index <= this._reelId && sym.indexOf("W") > -1){
                returnValue = false;
            }
        });
        return returnValue;
    }

    private getDistinctArrayItems(overlays:string[][]):string[]{
        let returnArray:string[] = [];
        const unique = (value:string, index:number, self:string[]) => {
            return self.indexOf(value) === index;
        }

        overlays.forEach((item) => {
            item.filter((value, index, self) => {
                if(self.indexOf(value) === index){
                    returnArray.push(value);
                }
            });
        });

        return returnArray.filter(unique);
    }
}